import Modal from "react-modal";
import { colors } from "../../data/colors";
import { calendarModalStyles } from "../../data/styles/modalStyles";
import { stdObject } from "../../data/types/stdObject";
import Header from "../componentModal/Header";
import useCalendarModal from "./useCalendarModal";
import Calendar from "../../screens/MainStructure/components/Calendar/Calendar";
import { getCurrentMonth } from "../../utils/getCurrentMonth";

export default function CalendarModal({
  open = false,
  close = () => {},
}: {
  open: boolean;
  close: () => void;
}) {
  const {
    selected,
    setSelected,
    secondFlex,
    calendarDays,
    isBigScreen,
    isMediumcreen,
    squareButtons,
    currentMonth,
    setCurrentMonth,
  } = useCalendarModal({
    open,
    close,
  });
  return (
    <Modal isOpen={open} onRequestClose={() => {}} style={calendarModalStyles}>
      <div className="documentContainer">
        <Header
          title={""}
          mainColor={colors.blue}
          squareInputs={[
            {
              type: "month",
              value: currentMonth,
              active: true,
              onChange: (e: stdObject) => {
                let value =
                  e.target.value === ""
                    ? getCurrentMonth()
                        .map((e: number, index: number) =>
                          index > 0 && e < 10 ? "0" + e : e,
                        )
                        .join("-")
                    : e.target.value;
                setCurrentMonth(value);
                setSelected("");
              },
            },
          ]}
          squareButtons={squareButtons}
          date={""}
        />
        <Calendar
          params={{
            selected,
            setSelected,
            secondFlex,
            calendarDays,
            isBigScreen,
            isMediumcreen,
          }}
        />
      </div>
    </Modal>
  );
}
